<!-- Builder Start -->
<div id="{{position}}" class="position-relative">
  <div class="app-header-background" [ngStyle]="{'background-color':backgroundColor}"
    [ngClass]="activatePadding?'header-padding-top':''">
    <div class="app-header-headline app-ecommerce-title">
      <h1 [ngStyle]="{ 'color': titleColor?titleColor:'#000000' }" class="mat-h1" [ngClass]="[titleSize]"
        [innerHtml]="title | safeHtml"></h1>
    </div>
    <div *ngIf="(assets$ | async) as assets" class="container-gird-list"
      [ngStyle]="{'max-width':maxWidth+'px','margin':'auto'}">
      <div class="assets" fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="center">
        <div *ngIf="assets && assets.length == 0" class="col-12 text-center p-4 no-asset">
          <p *ngIf="!loading" class="m-0" i18n="@@table.notFound">You don't have any asset yet.
            <a class="click-here" (click)="openAdmin()">Click here to add your first asset. </a>
          </p>
          <div class="demo-asset">
            <a *ngIf="!loading" class="app-button mat-raised-button" mat-raised-button="" rel="noopener" tabindex="0"
              aria-disabled="false" (click)="addDemoProduct()">
              <span class="mat-button-wrapper"> Add demo assets to your store </span>
            </a>
            <mat-spinner [diameter]="60" *ngIf="loading" style="margin: auto"></mat-spinner>
          </div>
        </div>
        <div *ngFor="let asset of assets" class="asset" fxFlex="1 1" fxFlexAlign="center"
          [ngStyle]="{'-ms-flex': (100/nbrProductsPerLine)+'%', 'flex':(100/nbrProductsPerLine)+'%', 'max-width':(100/nbrProductsPerLine)+'%','padding':'0 4px'}">
          <div class="article">
            <div>
              <img [src]="asset.image_url" alt="">
            </div>
            <section class="asset-detail">
              <div>
                <div fxFlex="1 1">
                  <div class="asset-creator" [ngStyle]="{ 'color': titleColor?titleColor:textColor }">
                    {{asset.asset_contract.name}}</div>
                  <div class="asset-title" [ngStyle]="{ 'color': titleColor?titleColor:textColor }">{{asset.name}}</div>
                </div>
                <div fxFlex="1 1" class="asset-price">
                  <div class="asset-creator" [ngStyle]="{ 'color': titleColor?titleColor:textColor }"> Last sale</div>
                  <div class="asset-title" [ngStyle]="{ 'color': titleColor?titleColor:textColor }"><img
                      src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/logos/eth.svg"
                      style="width: 8px;vertical-align: text-top;" alt="">
                      {{asset.last_sale?asset.last_sale.total_price/1000000000000000000:'-'}}</div>
                </div>
              </div>
              <a [href]="asset.permalink" target="_blank" style="text-decoration: none;">
                <div class="make-offer">
                  <mat-icon aria-hidden="false" aria-label="clear icon" style="font-size: 16px !important;
                  height: 8px;
                  width: 16px;
                  vertical-align: sub;">local_offer</mat-icon>
                  Make offer
                </div>
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Builder End -->

<!-- <img *ngIf="sliderIndex>-1 && !isString(imageBackground) && imageBackground[sliderIndex]"  style="display: none;" [src]="imageBackground[sliderIndex]" class="hero-image" [alt]="title" (error)="updateUrl($event)"> -->